


const TIMESTAMP = ($Glb, Vue) => {
	//timeStr 毫秒
	$Glb.timeStamp = (timeStr) =>{
		// let nowTime=new Date().now();//毫秒
		let nowTime=new Date().getTime();//毫秒
		let timeDifference=nowTime-timeStr; 

		let nowDate=new Date();
		let getDate=new Date(parseInt(timeStr) * 1000);

		// 当前年月日
		let curY=nowDate.getFullYear();
		let curM=nowDate.getMonth()+1;
			curM=curM>=10?curM:('0'+curM);
		let curD=nowDate.getDate();
			curD=curD>=10?curD:('0'+curD);
		// 获取给定年月日
		let Y=getDate.getFullYear();
		let M=getDate.getMonth()+1;
			M=M>=10?M:('0'+M);
		let D=getDate.getDate();
			D=D>=10?D:('0'+D);
		
		timeDifference/=1000;
		if(timeDifference<60){
			return Math.floor(timeDifference)+'秒前';
		}else if((timeDifference/60)<60){
			return Math.floor(timeDifference/60)+'分前';
		}else if(timeDifference/60/60<10){
			return Math.floor(timeDifference/60/60)+'小时前';
		}else if(timeDifference/60/60>10 &&Y==curY){
			return M+'-'+D;//如08-20
		}else{
			return Y+'-'+M+'-'+D
		}	
	}

}



export default TIMESTAMP







// WEBPACK FOOTER //
// ./src/plugins/glb_timeStamp/index.js